import Api from "../../../../lib/api";
import FormField from "../form-field";
import Select from "../select";

export default class CityField extends FormField {
	constructor(props) {
		super(props);

		this.select = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('CityField: Root element is not defined!');
		}

		this.select = new Select({
			$root: this.$root.querySelector('.listbox')
		});

		super.init();
		this.selectCurrentCity();
	}

	addEventListeners() {
		this.select.subscribe('valueChange', this.handleValueChange.bind(this));
	}

	handleValueChange(e) {
		this.setValue(e.detail);
		this.validateSoft();
	}

	validate() {
		this.isValid = this.value !== null;
	}

	setInitialState() {
		this.select.setInitialState();
	}

	setInitialValue(value) {
		this.select.selectOptionByValue(value);
	}

	selectCurrentCity() {
		let cityId = craft.env.cityId;

		if (!cityId) {
			cityId = Api.currentCityId;
		}

		if (!cityId) return;

		if (cityId == 'kz') {
			this.setValue(cityId);
			this.hide();
		} else {
			this.select.selectOptionByValue(cityId);
		}
	}
}